<template>
    <div class="home">
        <CarouselArticles v-if="articles" :articles="articles" heading="Åpenhetstiltak:"> </CarouselArticles>
        <ListPosts v-if="posts" :posts="posts" heading="Nyeste blogginnlegg:" button="Tidligere blogginnlegg" buttonTo="blogg"> </ListPosts>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CarouselArticles from '@/components/CarouselArticles.vue';
import ListPosts from '@/components/ListPosts.vue';

export default {
    name: 'Home',
    components: {
        CarouselArticles,
        ListPosts,
    },
    computed: mapState(['site', 'articles', 'posts']),
    created() {
        this.loadArticles();
        this.loadPosts({ limit: 3 });
    },
    methods: {
        ...mapActions(['loadArticles', 'loadPosts']),
    },
};
</script>
